export default __webpack_public_path__ + "static/media/Group1497-TataNeu@3x.69536d28.png";